<template>
    <div>
        <div class="reporting-list">
            <div>
                <div>Propojeni s terapeutem</div>
                <div>
                    {{ connectedPatients }}
                    <div class="reporting-info-icon">
                        <a>
                            <svg-icon icon="tooltips.small-info" />
                            <svg-icon icon="tooltips.small-info-hover" />
                            <div class="reporting-info-content">
                                <div>
                                    <p>Intenzivní fáze</p>
                                    <p>{{ connectedPatientsToolTip['intensive-connected'] }}</p>
                                </div>
                                <hr />
                                <div>
                                    <p>Udržovací fáze</p>
                                    <p>{{ connectedPatientsToolTip.sustain }}</p>
                                </div>
                                <hr />
                                <div>
                                    <p>Absolventi</p>
                                    <p>{{ connectedPatientsToolTip.graduate }}</p>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
                <div>
                    {{
                        connectedPatientsInPeriod['intensive-connected'] +
                            connectedPatientsInPeriod.sustain +
                            connectedPatientsInPeriod.graduate
                    }}
                    <div class="reporting-info-icon">
                        <a>
                            <svg-icon icon="tooltips.small-info" />
                            <svg-icon icon="tooltips.small-info-hover" />
                            <div class="reporting-info-content">
                                <div>
                                    <p>Intenzivní fáze</p>
                                    <p>{{ connectedPatientsInPeriod['intensive-connected'] }}</p>
                                </div>
                                <hr />
                                <div>
                                    <p>Udržovací fáze</p>
                                    <p>{{ connectedPatientsInPeriod.sustain }}</p>
                                </div>
                                <hr />
                                <div>
                                    <p>Absolventi</p>
                                    <p>{{ connectedPatientsInPeriod.graduate }}</p>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
                <div>
                    {{ connectedPatientsEvent }}
                </div>
            </div>
        </div>
        <div class="reporting-list bullet-blue">
            <div>
                <div>In-app</div>
                <div>
                    {{ inAppPatients }}
                </div>
                <div>
                    {{ inAppPatientsInPeriod }}
                </div>
                <div>
                    {{ inAppPatientsEvent }}
                </div>
            </div>
        </div>
        <div class="reporting-list bullet-orange">
            <div>
                <div>Onboarding</div>
                <div>
                    {{ onboardingPatients }}
                </div>
                <div>{{ onboardingPatientsInPeriod + onboardingPendingPatientsInPeriod }}</div>
                <div>{{ onboardingPatientsEvent + onboardingPendingPatientsEvent }}</div>
            </div>
        </div>
        <div class="reporting-list bullet-red">
            <div>
                <div>Deaktivovaní</div>
                <div class="w-calc--12">
                    {{ allInactivated(inactivatedPatients) }}
                    <div class="reporting-info-icon">
                        <a>
                            <svg-icon icon="tooltips.small-info" />
                            <svg-icon icon="tooltips.small-info-hover" />
                            <div class="reporting-info-content">
                                <div>
                                    <p>Z registrovaných</p>
                                    <p>{{ inactivatedPatients.onboarding }}</p>
                                </div>
                                <hr />
                                <div>
                                    <p>Z In-app</p>
                                    <p>{{ inactivatedPatients.in_app }}</p>
                                </div>
                                <hr />
                                <div>
                                    <p>Z propojených (intenzivní)</p>
                                    <p>{{ inactivatedPatients.intensive_phase }}</p>
                                </div>
                                <hr />
                                <div>
                                    <p>Z propojených (udržovací)</p>
                                    <p>{{ inactivatedPatients.sustain }}</p>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="w-calc--12">
                    {{
                        inactivatedPatientsInPeriod['intensive-connected'] +
                            inactivatedPatientsInPeriod.onboarding +
                            inactivatedPatientsInPeriod['intensive-inapp'] +
                            inactivatedPatientsInPeriod.sustain
                    }}
                    <div class="reporting-info-icon">
                        <a>
                            <svg-icon icon="tooltips.small-info" />
                            <svg-icon icon="tooltips.small-info-hover" />
                            <div class="reporting-info-content">
                                <div>
                                    <p>Z registrovaných</p>
                                    <p>
                                        {{ inactivatedPatientsInPeriod.onboarding }}
                                    </p>
                                </div>
                                <hr />
                                <div>
                                    <p>Z In-app</p>
                                    <p>{{ inactivatedPatientsInPeriod['intensive-inapp'] }}</p>
                                </div>
                                <hr />
                                <div>
                                    <p>Z propojených (intenzivní)</p>
                                    <p>{{ inactivatedPatientsInPeriod['intensive-connected'] }}</p>
                                </div>
                                <hr />
                                <div>
                                    <p>Z propojených (udržovací)</p>
                                    <p>{{ inactivatedPatientsInPeriod.sustain }}</p>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="w-calc--12">
                    {{
                        inactivatedPatientsEvent['intensive-connected'] +
                            inactivatedPatientsEvent.onboarding +
                            inactivatedPatientsEvent['intensive-inapp'] +
                            inactivatedPatientsEvent.sustain
                    }}
                    <div class="reporting-info-icon">
                        <a>
                            <svg-icon icon="tooltips.small-info" />
                            <svg-icon icon="tooltips.small-info-hover" />
                            <div class="reporting-info-content">
                                <div>
                                    <p>Z registrovaných</p>
                                    <p>
                                        {{ inactivatedPatientsEvent.onboarding }}
                                    </p>
                                </div>
                                <hr />
                                <div>
                                    <p>Z In-app</p>
                                    <p>{{ inactivatedPatientsEvent['intensive-inapp'] }}</p>
                                </div>
                                <hr />
                                <div>
                                    <p>Z propojených (intenzivní)</p>
                                    <p>{{ inactivatedPatientsEvent['intensive-connected'] }}</p>
                                </div>
                                <hr />
                                <div>
                                    <p>Z propojených (udržovací)</p>
                                    <p>{{ inactivatedPatientsEvent.sustain }}</p>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapActions, mapGetters } from 'vuex'

    export default {
        data() {
            return {
                regionsLocalStorageParsed: [],
                companiesLocalStorageParsed: [],
                dateFromLocalStorage: '',
                dateToLocalStorage: '',
                fetching: true
            }
        },

        computed: {
            ...mapGetters('reporting', [
                'connectedWithTherapist',
                'connectedWithTherapistToolTip',
                'inApp',
                'onboarding',
                'inactivated',
                'connectedWithTherapistInPeriod',
                'inAppInPeriod',
                'onboardingInPeriod',
                'onboardingPendingInPeriod',
                'inactivatedInPeriod',
                'connectedWithTherapistEvent',
                'connectedWithTherapistEventSustain',
                'connectedWithTherapistEventGraduate',
                'inAppEvent',
                'onboardingEvent',
                'onboardingPendingEvent',
                'inactivatedEvent'
            ]),

            connectedPatients() {
                return this.connectedWithTherapist
            },
            connectedPatientsToolTip() {
                return this.connectedWithTherapistToolTip
            },
            inAppPatients() {
                return this.inApp
            },
            onboardingPatients() {
                return this.onboarding
            },
            inactivatedPatients() {
                return this.inactivated
            },
            connectedPatientsInPeriod() {
                return this.connectedWithTherapistInPeriod
            },
            inAppPatientsInPeriod() {
                return this.inAppInPeriod
            },
            onboardingPatientsInPeriod() {
                return this.onboardingInPeriod
            },
            onboardingPendingPatientsInPeriod() {
                return this.onboardingPendingInPeriod
            },
            inactivatedPatientsInPeriod() {
                return this.inactivatedInPeriod
            },
            connectedPatientsEvent() {
                return this.connectedWithTherapistEvent
            },
            connectedPatientsEventSustain() {
                return this.connectedWithTherapistEventSustain
            },
            connectedPatientsEventGraduate() {
                return this.connectedWithTherapistEventGraduate
            },
            inAppPatientsEvent() {
                return this.inAppEvent
            },
            onboardingPatientsEvent() {
                return this.onboardingEvent
            },
            onboardingPendingPatientsEvent() {
                return this.onboardingPendingEvent
            },
            inactivatedPatientsEvent() {
                return this.inactivatedEvent
            }
        },

        created() {
            this.initialData()

            if (!this.fetching) {
                this.apiPatientsFunnel({
                    countries: this.regionsLocalStorageParsed,
                    institutions: this.companiesLocalStorageParsed
                })
                this.apiPatientsFunnelEvents({
                    countries: this.regionsLocalStorageParsed,
                    institutions: this.companiesLocalStorageParsed,
                    date_from: this.dateFromLocalStorage,
                    date_to: this.dateToLocalStorage
                })
            }
        },

        methods: {
            ...mapActions({
                apiPatientsFunnel: 'reporting/apiPatientsFunnel',
                apiPatientsFunnelEvents: 'reporting/apiPatientsFunnelEvents'
            }),

            allInactivated(inactivatedUsersFunnel) {
                let result = 0
                if (inactivatedUsersFunnel !== null) {
                    result =
                        inactivatedUsersFunnel.in_app +
                        inactivatedUsersFunnel.intensive_phase +
                        inactivatedUsersFunnel.onboarding +
                        inactivatedUsersFunnel.sustain
                }
                return result
            },

            initialData() {
                const regionsLocalStorage = window.localStorage.regions

                if (regionsLocalStorage) {
                    this.regionsLocalStorageParsed = JSON.parse(regionsLocalStorage)
                }

                const companiesLocalStorage = window.localStorage.companies

                if (companiesLocalStorage) {
                    this.companiesLocalStorageParsed = JSON.parse(companiesLocalStorage)
                }

                this.dateFromLocalStorage = window.localStorage.date_from
                this.dateToLocalStorage = window.localStorage.date_to

                if (!this.dateToLocalStorage && !this.dateFromLocalStorage) {
                    this.dateFromLocalStorage = moment()
                        .add(-7, 'days')
                        .format('YYYY-MM-DD')
                    this.dateToLocalStorage = moment().format('YYYY-MM-DD')
                }

                this.fetching = false

                return
            }
        }
    }
</script>
